










import { Vue, Component } from 'vue-property-decorator';
import EvidenciaBHP from '@/pantallas/EvidenciaBHP/EvidenciaBHP.vue';

@Component({
  components: { EvidenciaBHP },
})
export default class EvidenciaBHPPantalla extends Vue {}
